/*

# Event List

### TODO: 

- lazy loading callback 

*/

import React, { Component } from 'react';
import EventLI from 'ui/EventLI';
import { inTz } from 'utils/timezone';
import { isEmpty } from 'lodash';
import './index.css';

import Placeholder from 'ui/Placeholder';



export default class EventList extends Component {
  
  state = {
    limit: 100,
  }
  
  showMore = () => {
    this.setState({limit: this.state.limit + 50});
  }
  
  render() {
    const {date, events, tz} = this.props;
    
    let currDay = inTz(date, tz).startOf('day');
    let eventEls = Object.keys(events || {})
      .map(id => events[id])
      .filter(event => currDay.isBefore(event.endDate) || currDay.isSame(event.endDate, 'day'))
      .sort((a, b) => a.date < b.date ? -1 : 1)
      .slice(0, this.state.limit)
      .reduce((all, event) => {
        if(!currDay.isSame(event.date, 'day')) {
          currDay = inTz(event.date, tz);
          all = [...all,
            <div key={currDay.valueOf()} className="eventlist2-date">
              {currDay.calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                sameElse: 'MMMM Do, YYYY'
              })}
            </div>
          ];
        }
        all = [...all, 
          <EventLI 
            event={event} 
            key={event.id} 
            style={{marginBottom:4}}
            tz={tz}
            onClick={() => this.props.onClickEvent(event)}
          />
        ];
        
        return all;
      }, []);
    
    if(isEmpty(eventEls)) {
      return (
        <Placeholder
          icon="calendar"
          message={`There are no events scheduled after ${inTz(date, tz).format("dddd MMMM Do, YYYY")}.`}
          label="Add Event"
          onClick={this.props.onClickAdd}
        />
      );
    }
    
    return (
      <div className="eventlist2">
        {eventEls}
      </div>
    );
  }
}
